import Vue from "vue";

interface MixinState {
    formIsDirty: boolean;
    originalObject: any | null;
}

export default Vue.extend({
    data(): MixinState {
        return {
            formIsDirty: false,
            originalObject: null,
        }
    },
    methods: {
        isDirtyCheck: function (): boolean {
            if (this.formIsDirty) {
                return window.confirm(this.$vuetify.lang.t('$vuetify.formChangedMessage'))
            }
            return true;
        },
        isDirtySet: function () {
            this.formIsDirty = true;
        },
        isDirtyReset: function () {
            this.formIsDirty = false;
        },
        isDirtyChangeTracker: function(change: any) {
            console.log("changed called:");
            console.log(change);

            if (change != this.originalObject) {
                console.log("New object, reset formChanged!");
                this.originalObject = change;
                this.formIsDirty = false;
                return;
            }

            this.isDirtySet();
        },
        getIsDirty: function () {
            return this.formIsDirty;
        },
    },
    computed: {
    },
    beforeRouteLeave(to: any, from: any, next: any) {
        if (this.isDirtyCheck()) {
            return next()
        } else {
            return next(false)
        }
    },
})